export const adminHeaderStyle = {
  header: {
    backgroundColor: 'var(--default-white)',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    boxShadow: 'var(--box-shadow--1)',
    flexShrink: 0,
  },
  panel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0 auto',
    maxWidth: '1200px',
    minHeight: '80px',
    padding: '0 15px',
  },
  loginButton: {
    maxWidth: '175px',
    width: '100%',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
  },
  button: {
    background: 'var(--background-grey-op-50-1)',
  },
  modal: {
    '.MuiPaper-root': {
      maxWidth: '700px',
      padding: '48px 12px',
      width: '100%',
    },
  },
};
